var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 201,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "33.25%",
    y1: "13.682%",
    x2: "39.721%",
    y2: "55.787%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70F570",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AC729",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C628",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "82.011%",
    y1: "0%",
    x2: "56.588%",
    y2: "108.457%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29CDFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#148EFF",
    offset: "37.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A60FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.128%",
    y1: "-35.829%",
    x2: "30.44%",
    y2: "115.048%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8E7D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F74A5C",
    offset: "51.264%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F51D2C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h201v201H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.513 2.013L11.829 130.751l-8.353 14.426a4 4 0 003.462 6.004H146.52a4 4 0 003.493-5.949l-6.935-12.43a4 4 0 00-3.493-2.051H45.401a4 4 0 01-3.469-5.991L113.547 0H88.984a4 4 0 00-3.471 2.013z",
    fill: "url(#a)",
    transform: "translate(1 13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.192 151.445l.808-1.531-.007-.013a.02.02 0 000-.02L75.546 0 .494 130.754h3.921l.02.021h2.601l-.02-.021h6.53l.02.021h2.602l-.02-.021h6.529l.02.021h1.5l.414-.718-.008-.008 2.451-4.26.009.009.975-1.695-.008-.009 2.45-4.259.985-1.688-.008-.009 2.451-4.259.008.008.978-1.696-.009-.009 2.45-4.258.008.008.977-1.697-.008-.008 2.451-4.26.008.008.976-1.696-.007-.008 2.451-4.26.009.01.976-1.698-.008-.009 2.451-4.259.008.008.977-1.695-.009-.009 2.451-4.26.008.009.976-1.694-.009-.009 2.452-4.261.008.008.978-1.696-.009-.01 2.451-4.258.007.008.979-1.694-.01-.011 2.451-4.259.008.008.977-1.696-.009-.009 2.451-4.26.009.009.975-1.694-.009-.009 2.452-4.261.008.008.978-1.696-.009-.009 2.45-4.259.01.01.975-1.696-.009-.009 2.451-4.261.01.01.509-.889V41.1l2.744 4.714.034.035 10.111 17.376-.033-.035 4.027 6.921.034.036 10.112 17.377-.033-.035 4.029 6.921.029.03 10.117 17.385-.036-.037 4.028 6.922.035.037 10.111 17.374-.032-.033 4.026 6.921.035.036 10.113 17.38-.036-.038 4.028 6.923.037.039 1.491 2.562a.54.54 0 00.944-.02L152 169l.403-.852-.01-.01 2.317-4.399.009.01.923-1.753-.009-.009 2.316-4.399.009.01.922-1.754-.008-.008 2.316-4.398.004.007zM77.172 40.13a1.881 1.881 0 00-2.113-.868c-.112.03-.207.091-.309.139L62.462 26.57l2.447-4.264 53.636 56.003 9.889 17.146-48.592-50.737-2.67-4.588zm-.099-33.726l9.887 17.142L72.728 8.688l2.447-4.265 1.898 1.981zm13.824 23.971l9.888 17.143-31.48-32.868 2.448-4.265 19.144 19.99zm13.827 23.971l9.884 17.137-48.723-50.875 2.446-4.262 36.393 38zM5.215 128.873l-.923-.965 2.446-4.262 5.007 5.227h-6.53zm9.132 0l-6.633-6.926 2.447-4.264 10.715 11.189h-6.529v.001zm8.902-.238l-12.114-12.647 2.447-4.264L25.7 124.375l-2.451 4.26zm3.426-5.955l-12.118-12.654 2.447-4.264 12.122 12.659-2.451 4.259zm3.427-5.955l-12.123-12.661 2.446-4.262 12.127 12.663-2.45 4.26zm3.427-5.957l-12.13-12.663 2.448-4.264 12.132 12.669-2.45 4.258zm3.427-5.955L24.821 92.144l2.448-4.265 12.138 12.674-2.451 4.26zm3.426-5.957L28.245 86.18l2.446-4.261 12.142 12.679-2.451 4.258zM43.81 92.9L31.666 80.22l2.447-4.263L46.26 88.641 43.81 92.9zm3.426-5.956L35.087 74.259l2.447-4.263 12.152 12.688-2.45 4.26zm3.427-5.954L38.509 68.299l2.447-4.264 12.157 12.694-2.45 4.261zm3.427-5.958L41.932 62.336l2.447-4.263 12.162 12.7-2.451 4.259zm3.427-5.956L45.353 56.375l2.447-4.263 12.167 12.704-2.45 4.26zm3.427-5.955L48.775 50.415l2.447-4.264 12.172 12.71-2.45 4.26zm3.425-5.954L52.196 44.454l2.447-4.264 12.178 12.715-2.452 4.262zm3.429-5.959L55.619 38.492l2.447-4.263L70.248 46.95l-2.45 4.258zM73.671 41l-2.447 4.254-12.183-12.723 2.447-4.263 12.185 12.724-.002.008zm10.196 10.637l48.506 50.648 9.886 17.141-48.28-50.414-10.112-17.375zm14.141 24.298l48.189 50.319 9.886 17.141-47.964-50.084-10.111-17.376zm53.013 90.774l-.481-.502-10.111-17.377 12.909 13.479-2.317 4.4zm3.239-6.152l-17.861-18.65-10.11-17.374 30.288 31.626-2.317 4.398zm3.239-6.152L122.26 117.61l-10.115-17.383 47.671 49.78-2.317 4.398z",
    transform: "translate(39 13)",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#c)",
    fillRule: "nonzero",
    cx: 112,
    cy: 110,
    r: 17
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.33bc28c8146ec6179a9ecf2e44d3c5fd.svg";
export { ForwardRef as ReactComponent };